import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { NowCompactProductCard } from './NowCompactProductCard';
interface NowProduct {
  id: number;
  name: string;
  brand?: string;
  price: number;
  originalPrice?: number;
  discount?: number;
  rating?: number;
  reviewCount?: number;
  image: string;
  isBestSeller?: boolean;
  isNew?: boolean;
  expressDelivery?: boolean;
  isGlobal?: boolean;
  endingSoon?: boolean;
  availabilityStatus?: 'available' | 'unavailable';
}
interface NowProductRailProps {
  title: string;
  subtitle: string;
  viewAllLink: string;
  products: NowProduct[];
}
export function NowProductRail({
  title,
  subtitle,
  viewAllLink,
  products
}: NowProductRailProps) {
  const navigate = useNavigate();
  return <section aria-label={title} className="w-full" data-id="element-4556" data-mp="228gnpcne8ews">
      <div className="mb-4 flex items-end justify-between gap-4" data-id="element-4557" data-mp="2298gkfplvyjd">
        <div data-id="element-4558" data-mp="1x9vvo0iap1jf">
          <h2 className="text-xl font-bold tracking-tight text-gray-900 md:text-2xl" data-id="element-4559" data-mp="1xaf5etxskjmd">{title}</h2>
          <p className="mt-1 text-sm text-gray-600" data-id="element-4560" data-mp="3bur6rhhm17tz">{subtitle}</p>
        </div>
        <button type="button" onClick={() => navigate(viewAllLink)} className="inline-flex flex-shrink-0 items-center gap-1 text-sm font-bold text-brand transition-colors duration-150 hover:text-brand-dark" data-id="element-4561" data-mp="3gs956dy044nq">
          View all <ChevronRightIcon className="h-4 w-4" data-id="element-4562" data-mp="3qs9q24biqsu1" />
        </button>
      </div>
      <div className="grid grid-flow-col grid-rows-1 auto-cols-[calc((100%_-_16px)_/_3)] gap-2 overflow-x-auto pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:auto-cols-[calc((100%_-_16px)_/_3)] md:auto-cols-[185px] md:gap-3 lg:auto-cols-[205px]" data-id="element-4563" data-mp="3ursdp7uq5i0k">
        {products.map(product => <NowCompactProductCard key={product.id} product={product} data-id="element-4564" data-mp="dar20jt6bltn" />)}
      </div>
    </section>;
}